import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { X, MessageCircle, ExternalLink, ChevronLeft, ChevronRight } from 'lucide-react';
import AirlinesSection from '../components/AirlinesSection';
import HeroBackground from '../assets/Frame 4.svg';
import HeroBackground_Banner1 from '../assets/Travelsale_banner1.svg';
import HeroBackground_Banner_Brasil from '../assets/FRAME_BRASIL.webp';
import HeroBackground_Banner_Europa from '../assets/FrameEuropa.webp';
import HeroBackground_Banner2 from '../assets/bannerTravelSale2.svg';
import LOGO from '../assets/LOGO.svg';


const TravelSale = () => {
  const { slug } = useParams(); // Obtener slug de la URL
  const navigate = useNavigate(); // Para navegar entre rutas
  const [selectedImage, setSelectedImage] = useState(null);
  const [carouselIndexes, setCarouselIndexes] = useState({
    brasil: 0,
    argentina: 0,
    europa: 0,
    argentina2025: 0,
    feriadosNoviembre: 0
  });

  const brasilCards = [
    { id: 1, slug: "brasil-oferta-1", title: "Brasil Oferta 1", image: require("../assets/CARDS/BRA2026/Card_Brasil.webp"), link: "https://nocheydiaturismo.com/destino/Porto-Seguro-y-Arraial-D-Ajuda/5483" },
    { id: 2, slug: "brasil-oferta-2", title: "Brasil Oferta 2", image: require("../assets/CARDS/BRA2026/Card_Brasil1.webp"), link: "https://nocheydiaturismo.com/destino/Porto-Seguro-y-Arraial-D-Ajuda/5482" },
    { id: 3, slug: "brasil-oferta-3", title: "Brasil Oferta 3", image: require("../assets/CARDS/BRA2026/Card_Brasil2.webp"), link: "https://nocheydiaturismo.com/destino/Natal-y-Pipa/5470" },
    { id: 4, slug: "brasil-oferta-4", title: "Brasil Oferta 4", image: require("../assets/CARDS/BRA2026/Card_Brasil3.webp"), link: "https://nocheydiaturismo.com/destino/Natal-y-Pipa/5469" },
    { id: 5, slug: "brasil-oferta-5", title: "Brasil Oferta 5", image: require("../assets/CARDS/BRA2026/Card_Brasil4.webp"), link: "https://nocheydiaturismo.com/destino/Cabo-Fr%C3%ADo-y-R%C3%ADo-de-Janeiro/5475" },
    { id: 6, slug: "brasil-oferta-6", title: "Brasil Oferta 6", image: require("../assets/CARDS/BRA2026/Card_Brasil5.webp"), link: "https://nocheydiaturismo.com/destino/Buzios-y-Arraial-Do-Cabo/5620" },
    { id: 7, slug: "brasil-oferta-7", title: "Brasil Oferta 1", image: require("../assets/CARDS/BRA2026/Card_Brasil6.webp"), link: "https://nocheydiaturismo.com/destino/Maceio/5477" },
    { id: 8, slug: "brasil-oferta-8", title: "Brasil Oferta 2", image: require("../assets/CARDS/BRA2026/Card_Brasil7.webp"), link: "https://nocheydiaturismo.com/destino/Maragogi/5480" },
    { id: 9, slug: "brasil-oferta-9", title: "Brasil Oferta 3", image: require("../assets/CARDS/BRA2026/Card_Brasil8.webp"), link: "https://nocheydiaturismo.com/destino/Florian%C3%B3polis/5485" },
    { id: 10, slug: "brasil-oferta-10", title: "Brasil Oferta 4", image: require("../assets/CARDS/BRA2026/Card_Brasil9.webp"), link: "https://nocheydiaturismo.com/destino/Cambori%C3%BA/5487" },
    { id: 11, slug: "brasil-oferta-11", title: "Brasil Oferta 5", image: require("../assets/CARDS/BRA2026/Card_Brasil10.webp"), link: "https://nocheydiaturismo.com/destino/Cambori%C3%BA/5487" },
    { id: 12, slug: "brasil-oferta-12", title: "Brasil Oferta 6", image: require("../assets/CARDS/BRA2026/Card_Brasil11.webp"), link: "https://nocheydiaturismo.com/destino/Maceio/5478" }
  ];

  const argentinaCards = [
    { id: 13, slug: "argentina-oferta-1", title: "Argentina Oferta 1", image: require("../assets/CARDS/ARG2026/card_Argentina2026.webp"), link: "https://nocheydiaturismo.com/destino/Merlo/5575" },
    { id: 14, slug: "argentina-oferta-2", title: "Argentina Oferta 2", image: require("../assets/CARDS/ARG2026/card_Argentina2026_1.webp"), link: "https://nocheydiaturismo.com/destino/Merlo/5575" },
    { id: 15, slug: "argentina-oferta-3", title: "Argentina Oferta 3", image: require("../assets/CARDS/ARG2026/card_Argentina2026_2.webp"), link: "https://nocheydiaturismo.com/destino/Villa-Gesell/5603" },
    { id: 16, slug: "argentina-oferta-4", title: "Argentina Oferta 4", image: require("../assets/CARDS/ARG2026/card_Argentina2026_3.webp"), link: "https://nocheydiaturismo.com/destino/Mar-de-Aj%C3%B3/5576" },
    { id: 17, slug: "argentina-oferta-5", title: "Argentina Oferta 5", image: require("../assets/CARDS/ARG2026/card_Argentina2026_4.webp"), link: "https://nocheydiaturismo.com/destino/San-Bernardo/5604" },
    { id: 18, slug: "argentina-oferta-6", title: "Argentina Oferta 6", image: require("../assets/CARDS/ARG2026/card_Argentina2026_5.webp"), link: "https://nocheydiaturismo.com/destino/Ruta-40-al-Sur/5521" }
  ];

  const europaCards = [
    { id: 19, slug: "europa-oferta-1", title: "Europa Oferta 1", image: require("../assets/CARDS/EUR/Cards_Europa.webp"), link: "https://nocheydiaturismo.com/destino/Europa-Tur%C3%ADstica/5466" },
    { id: 20, slug: "europa-oferta-2", title: "Europa Oferta 2", image: require("../assets/CARDS/EUR/Cards_Europa_1.webp"), link: "https://nocheydiaturismo.com/destino/Ciudades-Imperiales-y-Polonia/5467" }
  ];

  const argentina2025Cards = [
    { id: 21, slug: "argentina-2025-1", title: "Argentina 2025 - 1", image: require("../assets/CARDS/ARG2025/card_Argentina2025.webp"), link: "https://nocheydiaturismo.com/destino/Calafate.Ushuaia/5613" },
    { id: 22, slug: "argentina-2025-2", title: "Argentina 2025 - 2", image: require("../assets/CARDS/ARG2025/card_Argentina2025_1.webp"), link: "https://nocheydiaturismo.com/destino/Glaciares-y-Chalten/5614" },
    { id: 23, slug: "argentina-2025-3", title: "Argentina 2025 - 3", image: require("../assets/CARDS/ARG2025/card_Argentina2025_2.webp"), link: "https://nocheydiaturismo.com/destino/Talampaya-y-Valle-de-la-Luna/5619" },
    { id: 24, slug: "argentina-2025-4", title: "Argentina 2025 - 4", image: require("../assets/CARDS/ARG2025/card_Argentina2025_3.webp"), link: "https://nocheydiaturismo.com/destino/San-Juan-y-Calingasta/5611" },
    { id: 25, slug: "argentina-2025-5", title: "Argentina 2025 - 5", image: require("../assets/CARDS/ARG2025/card_Argentina2025_4.webp"), link: "https://nocheydiaturismo.com/destino/San-Bernardo/5612" },
    { id: 26, slug: "argentina-2025-6", title: "Argentina 2025 - 6", image: require("../assets/CARDS/ARG2025/card_Argentina2025_5.webp"), link: "https://nocheydiaturismo.com/destino/Merlo/5608" },
    { id: 27, slug: "argentina-2025-7", title: "Argentina 2025 - 7", image: require("../assets/CARDS/ARG2025/card_Argentina2025_6.webp"), link: "https://nocheydiaturismo.com/destino/Mar-del-Plata-con-Tandil/5607" },
    { id: 28, slug: "argentina-2025-8", title: "Argentina 2025 - 8", image: require("../assets/CARDS/ARG2025/card_Argentina2025_7.webp"), link: "https://nocheydiaturismo.com/destino/Puerto-Madryn/5610" },
    { id: 29, slug: "argentina-2025-9", title: "Argentina 2025 - 8", image: require("../assets/CARDS/ARG2025/card_Argentina2025_8.webp"), link: "https://nocheydiaturismo.com/destino/Chilecito_-Termas-de-Fiambal%C3%A1-y-Aimogasta/5605" },
    { id: 30, slug: "argentina-2025-10", title: "Argentina 2025 - 9", image: require("../assets/CARDS/ARG2025/card_Argentina2025_9.webp"), link: "https://nocheydiaturismo.com/destino/Cataratas-del-Iguaz%C3%BA/5609" }
  ];

  const feriadosNoviembre = [
    { id: 31, slug: "noviembre-oferta-1", title: "Noviembre Oferta 1", image: require("../assets/CARDS/NOV/card_feriado_NOV.webp"), link: "https://nocheydiaturismo.com/destino/La-Falda/5586" },
    { id: 32, slug: "noviembre-oferta-2", title: "Noviembre Oferta 2", image: require("../assets/CARDS/NOV/card_feriado_NOV_1.webp"), link: "https://nocheydiaturismo.com/destino/Merlo/5590" },
    { id: 33, slug: "noviembre-oferta-3", title: "Noviembre Oferta 3", image: require("../assets/CARDS/NOV/card_feriado_NOV_2.webp"), link: "https://nocheydiaturismo.com/destino/San-Luis-y-Sierra-de-las-Quijadas/5594" },
    { id: 34, slug: "noviembre-oferta-4", title: "Noviembre Oferta 4", image: require("../assets/CARDS/NOV/card_feriado_NOV_3.webp"), link: "https://nocheydiaturismo.com/destino/Mendoza-con-Termas-de-Cacheuta/5595" },
    { id: 35, slug: "noviembre-oferta-5", title: "Noviembre Oferta 5", image: require("../assets/CARDS/NOV/card_feriado_NOV_4.webp"), link: "https://nocheydiaturismo.com/destino/San-Rafael-y-Reyunos/5597" },
    { id: 36, slug: "noviembre-oferta-6", title: "Noviembre Oferta 6", image: require("../assets/CARDS/NOV/card_feriado_NOV_5.webp"), link: "https://nocheydiaturismo.com/destino/Talampaya-y-Valle-de-la-Luna/5598" },
    { id: 37, slug: "noviembre-oferta-7", title: "Noviembre Oferta 7", image: require("../assets/CARDS/NOV/card_feriado_NOV_6.webp"), link: "https://nocheydiaturismo.com/destino/Mar-del-Plata/5582" },
    { id: 38, slug: "noviembre-oferta-8", title: "Noviembre Oferta 8", image: require("../assets/CARDS/NOV/card_feriado_NOV_7.webp"), link: "https://nocheydiaturismo.com/destino/San-Bernardo/5579" },
    { id: 39, slug: "noviembre-oferta-9", title: "Noviembre Oferta 9", image: require("../assets/CARDS/NOV/card_feriado_NOV_8.webp"), link: "https://nocheydiaturismo.com/destino/Cataratas-del-Iguaz%C3%BA/5602" },
    { id: 40, slug: "noviembre-oferta-10", title: "Noviembre Oferta 10", image: require("../assets/CARDS/NOV/card_feriado_NOV_9.webp"), link: "https://nocheydiaturismo.com/destino/Puerto-Madryn/5601" },
    { id: 41, slug: "noviembre-oferta-11", title: "Noviembre Oferta 11", image: require("../assets/CARDS/NOV/card_feriado_NOV_10.webp"), link: "https://nocheydiaturismo.com/destino/Villa-Giardino/5588" },
    { id: 42, slug: "noviembre-oferta-12", title: "Noviembre Oferta 12", image: require("../assets/CARDS/NOV/card_feriado_NOV_11.webp"), link: "https://nocheydiaturismo.com/destino/Termas-de-Federaci%C3%B3n/5593" },
    { id: 43, slug: "noviembre-oferta-13", title: "Noviembre Oferta 13", image: require("../assets/CARDS/NOV/card_feriado_NOV_12.webp"), link: "https://nocheydiaturismo.com/destino/Villa-Carlos-Paz/5584" },
    { id: 44, slug: "noviembre-oferta-14", title: "Noviembre Oferta 14", image: require("../assets/CARDS/NOV/card_feriado_NOV_13.webp"), link: "https://nocheydiaturismo.com/destino/Mar-del-Plata-con-Tandil/5581" },
    { id: 45, slug: "noviembre-oferta-15", title: "Noviembre Oferta 15", image: require("../assets/CARDS/NOV/card_feriado_NOV_14.webp"), link: "https://nocheydiaturismo.com/destino/Mar-de-Aj%C3%B3/5580" },
    { id: 46, slug: "noviembre-oferta-16", title: "Noviembre Oferta 16", image: require("../assets/CARDS/NOV/card_feriado_NOV_15.webp"), link: "https://nocheydiaturismo.com/destino/San-Juan-y-Calingasta/5606" }
  ];

  const services = [
    { icon: "🏨", title: "Hoteles", description: "Las mejores opciones de alojamiento" },
    { icon: "✈️", title: "Vuelos", description: "Vuelos nacionales e internacionales" },
    { icon: "🚗", title: "Traslados", description: "Servicios de transporte" },
    { icon: "🎯", title: "Excursiones", description: "Tours y experiencias únicas" }
  ];

  // Combinar todas las cards
  const allCards = [...brasilCards, ...argentinaCards, ...europaCards, ...argentina2025Cards, ...feriadosNoviembre];

  // Función para encontrar una card por slug
  const findCardBySlug = (slug) => {
    return allCards.find(card => card.slug === slug);
  };

  // useEffect para manejar el slug de la URL
  useEffect(() => {
    if (slug) {
      const card = findCardBySlug(slug);
      if (card) {
        setSelectedImage(card);
      }
    } else {
      setSelectedImage(null);
    }
  }, [slug]);

  // Función para abrir modal (ahora usa navigate)
  const openModal = (card) => {
    setSelectedImage(card);
    navigate(`/${card.slug}`);
  };

  // Función para cerrar modal (navegar a home)
  const closeModal = () => {
    setSelectedImage(null);
    navigate('/');
  };

  const handleWhatsApp = () => {
    window.open('https://wa.me/5491171628293', '_blank');
  };

const handleWebsite = () => {
  if (selectedImage && selectedImage.link) {
    window.open(selectedImage.link, '_blank');
  }
};

const nextSlide = (carouselName, totalCards) => {
  const itemsPerSlide = getItemsPerSlide();
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
  const totalRows = isMobile ? 1 : 2;
  const cardsPerPage = itemsPerSlide * totalRows;
  const maxIndex = Math.ceil(totalCards / cardsPerPage) - 1;
  
  setCarouselIndexes(prev => ({
    ...prev,
    [carouselName]: prev[carouselName] >= maxIndex ? 0 : prev[carouselName] + 1
  }));
};

const prevSlide = (carouselName, totalCards) => {
  const itemsPerSlide = getItemsPerSlide();
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
  const totalRows = isMobile ? 1 : 2;
  const cardsPerPage = itemsPerSlide * totalRows;
  const maxIndex = Math.ceil(totalCards / cardsPerPage) - 1;
  
  setCarouselIndexes(prev => ({
    ...prev,
    [carouselName]: prev[carouselName] <= 0 ? maxIndex : prev[carouselName] - 1
  }));
};

  const getItemsPerSlide = () => {
    if (typeof window !== 'undefined') {
      if (window.innerWidth >= 1024) return 3;
      if (window.innerWidth >= 768) return 2;
      return 1;
    }
    return 3;
  };

const Carousel = ({ cards, carouselName, title, subTitle }) => {
  const itemsPerSlide = getItemsPerSlide();
  const currentIndex = carouselIndexes[carouselName];
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
  const totalRows = isMobile ? 1 : 2;
  const cardsPerPage = itemsPerSlide * totalRows;
  const startIndex = currentIndex * cardsPerPage;
  const visibleCards = cards.slice(startIndex, startIndex + cardsPerPage);
  const totalSlides = Math.ceil(cards.length / cardsPerPage);

    return (
      <section className="container mx-auto px-4 pb-8 pb-8 py-8">
        <div className="text-center mb-8">
          <h4 className="text-2xl md:text-1xl font-bold text-gray-800 mb-4">{subTitle}</h4>
          <h1 className="text-2xl md:text-4xl font-bold text-gray-800 mb-4">{title}</h1>
        </div>
        
        <div className="relative">
          {totalSlides > 1 && (
            <>
              <button
                onClick={() => prevSlide(carouselName, cards.length)}
                className="absolute left-4 top-1/2 -translate-y-1/2 z-10 bg-white shadow-lg rounded-full p-3 hover:shadow-xl transition-all duration-300 hover:scale-110"
                aria-label="Anterior"
              >
                <ChevronLeft size={24} className="text-gray-600" />
              </button>
              
              <button
                onClick={() => nextSlide(carouselName, cards.length)}
                className="absolute right-4 top-1/2 -translate-y-1/2 z-10 bg-white shadow-lg rounded-full p-3 hover:shadow-xl transition-all duration-300 hover:scale-110"
                aria-label="Siguiente"
              >
                <ChevronRight size={24} className="text-gray-600" />
              </button>
            </>
          )}

            {/*<div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-8 max-w-5xl mx-auto">*/}
            <div className="overflow-hidden md:overflow-visible">
                <div className="flex md:flex-wrap md:justify-center gap-2 md:gap-3 mb-8 max-w-5xl mx-auto">   
                
                  {visibleCards.map((card) => (
                    <div
                      key={card.id}
                      className="cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-xl w-full max-w-sm mx-auto md:max-w-xs flex-shrink-0"
                      onClick={() => openModal(card)}
                    >
                      <div className="bg-white rounded-lg overflow-hidden shadow-lg">
                        <img
                          src={card.image}
                          alt={card.title}
                          className="w-full aspect-[0,5] object-fit"
                        />
                      </div>
                    </div>
                  ))}
              </div>
            </div>

          {totalSlides > 1 && (
            <div className="flex justify-center space-x-2">
              {Array.from({ length: totalSlides }, (_, index) => (
                <button
                  key={index}
                  onClick={() => setCarouselIndexes(prev => ({ ...prev, [carouselName]: index }))}
                  className={`w-3 h-3 rounded-full transition-all duration-300 ${
                    index === currentIndex 
                      ? 'bg-purple-500 scale-125' 
                      : 'bg-gray-300 hover:bg-gray-400'
                  }`}
                  aria-label={`Ir a slide ${index + 1}`}
                />
              ))}
            </div>
          )}
        </div>
      </section>
    );
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="relative bg-gradient-to-r from-white-600 via-white-500 text-white overflow-hidden">
        <img src={HeroBackground} alt="Hero Background"/>
        <div className="container mx-auto px-4 py-8 md:py-12">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
          </div>
        </div>
        <div className="absolute top-0 right-0 w-24 h-24 md:w-32 md:h-32 bg-yellow-300 rounded-full opacity-20 -translate-y-12 translate-x-12 md:-translate-y-16 md:translate-x-16"></div>
        <div className="absolute bottom-0 left-0 w-16 h-16 md:w-24 md:h-24 bg-pink-300 rounded-full opacity-20 translate-y-8 -translate-x-8 md:translate-y-12 md:-translate-x-12"></div>
      </header>

      {/* Sección Brasil 2026 */}
      <Carousel cards={brasilCards} carouselName="brasil" title="Verano Brasil 2026" subTitle="Travel Sale" className="pb-15" />

      {/* Banner Travel Sale */}
      <section className="relative w-full">
        <div className="relative overflow-hidden">
          <img 
            src={HeroBackground_Banner_Brasil} 
            alt="Hero Background" 
            className="w-full h-auto mx-auto object-contain"
          />
          <div className="absolute top-0 left-0 right-0 h-4 bg-gradient-to-b from-white to-transparent pointer-events-none"></div>
          <div className="absolute bottom-0 left-0 right-0 h-4 bg-gradient-to-t from-white to-transparent pointer-events-none"></div>
        </div>
      </section>

      {/* Sección Argentina 2026 */}
      <Carousel cards={argentinaCards} carouselName="argentina" title="Verano Argentina 2026" subTitle="Travel Sale" />

      {/* Banner Travel Sale */}
      <section className="relative w-full">
        <div className="relative overflow-hidden">
          <img 
            src={HeroBackground_Banner1} 
            alt="Hero Background" 
            className="w-full h-auto mx-auto object-contain"
          />
          <div className="absolute top-0 left-0 right-0 h-4 bg-gradient-to-b from-white to-transparent pointer-events-none"></div>
          <div className="absolute bottom-0 left-0 right-0 h-4 bg-gradient-to-t from-white to-transparent pointer-events-none"></div>
        </div>
      </section>

      {/* Sección Europa 2026 */}
      <Carousel cards={europaCards} carouselName="europa" title="Europa 2026" subTitle="Travel Sale" />

      {/* Banner Travel Sale */}
      <section className="relative w-full">
        <div className="relative overflow-hidden">
          <img 
            src={HeroBackground_Banner_Europa} 
            alt="Hero Background" 
            className="w-full h-auto mx-auto object-contain"
          />
          <div className="absolute top-0 left-0 right-0 h-4 bg-gradient-to-b from-white to-transparent pointer-events-none"></div>
          <div className="absolute bottom-0 left-0 right-0 h-4 bg-gradient-to-t from-white to-transparent pointer-events-none"></div>
        </div>
      </section>

      {/* Ofertas Argentina 2025 */}
      <Carousel cards={argentina2025Cards} carouselName="argentina2025" title="Ofertas Argentina 2025" subTitle="Travel Sale" />

      {/* Banner Travel Sale */}
      <section className="relative w-full">
        <div className="relative overflow-hidden">
          <img 
            src={HeroBackground_Banner2} 
            alt="Hero Background" 
            className="w-full h-auto mx-auto object-contain"
          />
          <div className="absolute top-0 left-0 right-0 h-4 bg-gradient-to-b from-white to-transparent pointer-events-none"></div>
          <div className="absolute bottom-0 left-0 right-0 h-4 bg-gradient-to-t from-white to-transparent pointer-events-none"></div>
        </div>
      </section>

      {/* Feriados Noviembre */}
      <Carousel cards={feriadosNoviembre} carouselName="feriadosNoviembre" title="Feriados Noviembre" subTitle="Travel Sale"/>

      {/* Servicios */}
      <section className="bg-gray-50 py-12 md:py-16">
        <div className="container mx-auto px-4">
          <div className="text-center mb-8 md:mb-12">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">Ofrecemos Los Mejores Servicios</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            {services.map((service, index) => (
              <div key={index} className="text-center">
                <div className="text-3xl md:text-4xl mb-4">{service.icon}</div>
                <h1 className="text-lg md:text-xl font-semibold text-gray-800 mb-2">{service.title}</h1>
                <p className="text-sm md:text-base text-gray-600">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Partners */}
      <section className="container mx-auto px-4 py-12 md:py-16">
        <AirlinesSection />
      </section>

      {/* Footer CTA */}
      <footer className="bg-gradient-to-r from-purple-600 to-pink-500 text-white py-8 md:py-12">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center justify-between gap-8">
            <div className="text-center md:text-left">
              <h2 className="text-xl md:text-2xl font-bold mb-2">#TRAVELSALE25</h2>
              <p className="text-base md:text-lg">25 AL 31 DE AGOSTO</p>
            </div>
            <div className="text-center md:text-right flex-1 max-w-md">
              <h3 className="text-lg md:text-xl font-semibold mb-2">QUE DICEN LAS PERSONAS DE NOSOTROS</h3>
              <p className="text-sm md:text-base mb-4">Suscríbete para recibir información, noticias turísticas y ofertas promocionales.</p>
              <div className="flex flex-col sm:flex-row gap-4">
                <input
                  type="email"
                  placeholder="Tu email"
                  className="flex-1 px-4 py-2 rounded-lg text-gray-800 text-sm md:text-base"
                />
                <button className="bg-orange-500 hover:bg-orange-600 px-4 md:px-6 py-2 rounded-lg font-semibold transition-colors text-sm md:text-base">
                  Suscribirse
                </button>
              </div>
            </div>
          </div>
        </div>
      </footer>


      {/* Footer */}
      <footer className="bg-gray-100 py-8 md:py-12">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            
            {/* Logo y descripción */}
            <div className="text-center md:text-left">
              <div className="flex items-center justify-center md:justify-start mb-4">
                <div className="w-12 h-12 flex items-center justify-center mr-3">
                  <img 
                    src={LOGO}
                    alt="Noche y Día Turismo" 
                    className="w-12 h-12 object-contain"
                  />
                </div>
                <div>
                  <h3 className="font-bold text-gray-800">Noche y Día Turismo</h3>
                  <p className="text-sm text-gray-600">Desde 1993 junto a ustedes</p>
                </div>
              </div>
              
              <div className="mb-4">
                <h4 className="font-semibold text-gray-800 mb-2">Horarios de atención</h4>
                <ul className="text-sm text-gray-600 space-y-1">
                  <li>• Lunes a viernes de 10 a 13 hs.</li>
                  <li>de 14 hs a 18 hs.</li>
                  <li>• Sábados de 10 a 13 hs.</li>
                </ul>
              </div>
              
              <div className="text-xs text-gray-500">
                <p className="mb-1">Defensa al consumidor presione <a href="#" className="text-blue-500 underline">aquí</a>.</p>
                <p>Denuncia contra una agencia presione <a href="#" className="text-blue-500 underline">aquí</a>.</p>
              </div>
            </div>

            {/* Destinos */}
            <div className="text-center md:text-left">
              <h4 className="font-semibold text-gray-800 mb-4">Destinos</h4>
              <ul className="text-sm text-gray-600 space-y-2">
                <li><a href="#" className="hover:text-purple-600 transition-colors">Ruta 40 al Sur</a></li>
                <li><a href="#" className="hover:text-purple-600 transition-colors">Cabo Frío y Río de Janeiro</a></li>
                <li><a href="#" className="hover:text-purple-600 transition-colors">Camboriú</a></li>
                <li><a href="#" className="hover:text-purple-600 transition-colors">Florianópolis</a></li>
                <li><a href="#" className="hover:text-purple-600 transition-colors">Porto Seguro y Arraial D'Ajuda</a></li>
                <li><a href="#" className="hover:text-purple-600 transition-colors">Búzios y Arraial Do Cabo</a></li>
                <li><a href="#" className="hover:text-purple-600 transition-colors">Maragogi</a></li>
                <li><a href="#" className="hover:text-purple-600 transition-colors">Maceio</a></li>
                <li><a href="#" className="hover:text-purple-600 transition-colors">Natal y Pipa</a></li>
              </ul>
            </div>

            {/* Contacto */}
            <div className="text-center md:text-left">
              <h4 className="font-semibold text-gray-800 mb-4">Contacto</h4>
              <div className="text-sm text-gray-600 space-y-3">
                <div className="flex items-start justify-center md:justify-start">
                  <span className="mr-2">📍</span>
                  <span>Yerbal 1136 PB (C1405BWA). CABA, Argentina</span>
                </div>
                <div className="flex items-center justify-center md:justify-start">
                  <span className="mr-2">📞</span>
                  <span>(011) 4432 8675</span>
                </div>
                <div className="flex items-center justify-center md:justify-start">
                  <span className="mr-2">✉️</span>
                  <span>consulta@nocheydiaturismo.com</span>
                </div>
                <br></br><br></br><br></br><br></br><br></br><br></br>
                <div className="flex items-center justify-center md:justify-start">
                  <p>Todos los derechos reservados a Noche y Día Turismo</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Modal */}
      {selectedImage && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
          <div className="rounded-lg max-w-4xl max-h-[90vh] overflow-hidden relative w-full mx-4">
            <button
              onClick={closeModal}
              className="absolute top-4 right-4 z-10 bg-white rounded-full p-2 hover:bg-gray-100 transition-colors shadow-lg"
            >
              <X size={24} />
            </button>
            
            <div className="p-4 md:p-6">
              <img
                src={selectedImage.image}
                alt={selectedImage.title}
                className="w-full h-auto max-h-[50vh] md:max-h-[76vh] object-contain rounded-lg mb-4 md:mb-6"
              />
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <button
                  onClick={handleWhatsApp}
                  className="flex items-center justify-center gap-2 bg-green-500 hover:bg-green-600 text-white px-4 md:px-6 py-3 rounded-lg font-semibold transition-colors text-sm md:text-base"
                >
                  <MessageCircle size={20} />
                  WhatsApp
                </button>
                
                <button
                  onClick={handleWebsite}
                  className="flex items-center justify-center gap-2 bg-blue-500 hover:bg-blue-600 text-white px-4 md:px-6 py-3 rounded-lg font-semibold transition-colors text-sm md:text-base"
                >
                  <ExternalLink size={20} />
                  Sitio Web
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TravelSale;